<template>
  <v-autocomplete
    :label="label"
    :value="current"
    :items="candidate"
    :loading="loading"
    :filter="inputFilter"
    :item-text="(item) => item.delivery1 + ' ' + item.delivery2"
    item-value="deliveryCode"
    :disabled="fieldDisabled"
    @change="onSelected"
    clearable
    hide-no-data
    filled
    dense
    :rules="rules"
    :attach="attach"
    :error-messages="fieldErrorMessages"
  ></v-autocomplete>
</template>

<script>
export default {
  name: "DeliveryAllField",
  model: { prop: "code", event: "selected" },
  props: {
    label: { type: String, default: "配送先名" },
    code: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    attach: { type: Boolean, default: true },
    groupCodes: { type: Array, default: () => [] },
    disabledNoData: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] },
    errorMessages: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: null,
      candidate: [],
      current: null,
      inputFilter: (item, queryText) =>
        item.deliveryCode.includes(queryText) || (item.delivery1 + " " + item.delivery2).includes(queryText),
    };
  },
  async mounted() {
    await this.initDeliveries(this.groupCodes, this.code);
  },
  watch: {
    async code(value) {
      if (value) {
        if (this.current == null || this.current.deliveryCode !== value) {
          await this.initDeliveries(this.groupCodes, value);
        }
      } else {
        this.current = null;
      }
    },
  },
  computed: {
    fieldDisabled() {
      return this.disabled || (this.disabledNoData && this.candidate.length === 0);
    },
    fieldErrorMessages() {
      return this.errorMessages;
    },
  },
  methods: {
    onSelected(value) {
      this.current = this.candidate.find((c) => c.deliveryCode === value);
      this.$emit("selected", value);
    },
    selected() {
      return this.current;
    },
    async initDeliveries(groupCodes, deliveryCode) {
      try {
        this.loading = true;
        let response = [];
        this.candidate = [];
        if (groupCodes != null && Array.isArray(groupCodes) && groupCodes.length > 0) {
          this.candidate = [];

          for (let i = 0; i < groupCodes.length; i++) {
            const row = groupCodes[i];
            response = await this.$store.dispatch("deliveryDestination/searchDelivery", { groupCode: row });
            if (response.data?.contents?.deliveries) {
              var rowDates = response.data.contents.deliveries;
              for (let j = 0; j < rowDates.length; j++) {
                const delivery = rowDates[j];
                if (!delivery || this.candidate.some((val) => val.deliveryCode === delivery.deliveryCode)) continue;
                this.candidate.push(delivery);
              }
            }
          }
        } else {
          response = await this.$store.dispatch("deliveryDestination/searchDelivery", {});
          if (response.data?.contents?.deliveries) {
            this.candidate = response.data.contents.deliveries;
          } else {
            this.candidate = [];
          }
        }

        if (this.candidate.length === 0) {
          this.current = null;
          this.$emit("selected", null);
        } else {
          this.current = this.candidate.find((c) => c.deliveryCode === deliveryCode);
          this.$emit("selected", this.current ? this.current.deliveryCode : null);
        }
      } catch (error) {
        console.error("DeliveryAllField::initDeliveries", error);
      } finally {
        this.loading = false;
      }
    },
    async getDeliveriesList(groupCd) {
      return await this.$store.dispatch("deliveryDestination/searchDelivery", { groupCode: groupCd });
    },
  },
};
</script>
